import script from "./FormBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormBlock.vue?vue&type=script&setup=true&lang=ts"

import "./FormBlock.vue?vue&type=style&index=0&id=2f5c69fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5c69fa"]])

export default __exports__